import React, { FC, useEffect, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';

import Dialog from '../../common/modals/dialog';
import TextField from '../../common/text-field';
import { VarFormInstance } from './types';
import api from '../../../api/api';

interface CreateVarProps {
  open: boolean;
  setOpen(value: boolean): void;
  variable?: VarFormInstance;
}

const EditVar: FC<CreateVarProps> = ({ open, setOpen, variable }) => {
  const [key, setKey] = useState<string>(variable?.key || '');
  const [value, setValue] = useState<string>(variable?.value || '');
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    if (variable) {
      await api.service.updateVar('' + variable.id, { value });
    } else {
      await api.service.addVar({ key, value });
    }
    setLoading(false);
    setOpen(false);
  };

  useEffect(() => {
    setKey(variable?.key || '');
    setValue(variable?.value || '');
  }, [variable]);

  return (
    <Dialog
      title="Переменная системы"
      open={open}
      onClose={() => setOpen(false)}
      loading={loading}
      actions={
        <>
          <Button onClick={onSubmit}>
            {!variable ? 'Добавить' : 'Изменить'}
          </Button>
        </>
      }
    >
      <Box mb={1} >
        <TextField
          disabled={!!variable}
          id=""
          label="Ключ"
          value={key}
          onChange={setKey}
        />
      </Box>
      <Box mb={1}>
        <TextField
          multiline
          rows={10}
          id=""
          label="Значение"
          value={value}
          onChange={setValue}
        />
      </Box>
    </Dialog>
  );
};

export default EditVar;
